import { ReactNode } from "react";
import { selectFeatureFlags } from "../context/slices/featureFlagsSlice";
import { useXNGSelector } from "../context/store";
import IfElseBox from "../design/components-dev/if_else_box";
import InactiveUserView from "../views/registration_flow/user_onboarding/inactive_user_view";
import MaintenanceSplashPage from "./maintenanceSplashPage";
import { msalInstance } from "./msalInstance";

interface AuthFlowControllerProps {
  readonly children: ReactNode;
  readonly userInactive: boolean;
}

/**
 * AuthFlowController component handles maintenance mode and inactive user checks.
 * It wraps the application and conditionally renders maintenance or inactive user views.
 */
export function AuthFlowController({ children, userInactive }: Readonly<AuthFlowControllerProps>) {
  const maintenanceModeActive = useXNGSelector((state) =>
    selectFeatureFlags(state, "MaintenenceMode"),
  );

  return (
    <IfElseBox
      if={maintenanceModeActive}
      then={<MaintenanceSplashPage onLogout={() => msalInstance.logoutRedirect()} />}
      else={
        <IfElseBox
          if={userInactive}
          then={<InactiveUserView onLogout={() => msalInstance.logoutRedirect()} />}
          else={<>{children}</>}
        />
      }
    />
  );
}
